import { useEffect, useState } from "react";
import style from "./MyAddressSearch.module.css";
import { FiSearch } from "react-icons/fi";

function MyAddressSearch({ search }) {
  const [key, setkey] = useState("");

  useEffect(() => {
    const timeOut = setTimeout(() => {
      search(key);
    }, 1400);
    return () => clearTimeout(timeOut);
  }, [key]);

  return (
    <div className={"mb-3 " + style.box} style={{ maxWidth: 400 }}>
      <input
        type="text"
        className={style.input}
        placeholder="جستجو با استان، شهر، آدرس، نام، موبایل"
        onChange={e => setkey(e.target.value)}
      />
      <button className={"buttonUi " + style.icon}>
        <FiSearch />
      </button>
    </div>
  );
}

export default MyAddressSearch;
